// For a complete list of dependencies refer to the dependencies in package.json.

// Added to support older IE, Android, and iOS device web browsers: See link below for more details
// https://bootstrap-vue.js.org/docs/#browser-support
import "core-js/stable";
import "regenerator-runtime/runtime";
import "intersection-observer"; // Note: This is optional

import Vue from "vue";

// https://bootstrap-vue.org/
import BootstrapVue from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

// https://vuelidate.js.org/
import Vuelidate from "vuelidate";

// https://www.npmjs.com/package/vue-inputmask
import VueInputMask from "vue-inputmask";

// https://router.vuejs.org/
import router from "./router";

// https://vuex.vuejs.org/
import store from "./store";

import App from "./App.vue";

Vue.config.productionTip = false;

Vue.use(BootstrapVue);
Vue.use(Vuelidate);
Vue.use(VueInputMask.default);

new Vue({
  render: (h) => h(App),
  router,
  store,
}).$mount("#app");
